<template>
  <div class="person-list">
    <div class="middle">
      <div v-if="renderedPersons.length" class="persons">
        <slot v-for="person in renderedPersons" :person="person" />
        <div class="spacer"></div>
      </div>
      <div v-else class="no-persons">
        <h3>Keine Person gefunden.</h3>
      </div>
      <Searchbar
        v-if="hasSearchbar"
        :shown="hasSearchbar && showSearchbar"
        :triangleMargin="searchbarMargin"
        @change="searchTerm = arguments[0]"
        @show="showSearchbar = arguments[0]"
      />
    </div>
    <ActionBar v-if="actions.length > 0" :actions="getActions" />
  </div>
</template>

<script>
import escapeRegex from 'escape-string-regexp';
import Searchbar from '@/components/person-list/Searchbar.vue';
import ActionBar from '@/components/ActionBar.vue';

export default {
  name: 'PersonList',
  components: {
    Searchbar,
    ActionBar,
  },
  props: {
    persons: {
      type: Array,
      required: true,
    },
    allPersons: Array,
    showAll: {
      type: Boolean,
      default: false,
    },
    hasSearchbar: {
      type: Boolean,
      default: false,
    },
    actions: {
      type: Array,
      default: () => [],
    },
    searchbarMargin: String,
  },
  data: () => ({
    showSearchbar: false,
    searchTerm: '',
  }),
  methods: {
    isSearchedPerson(person) {
      return new RegExp(escapeRegex(this.searchTerm.trim()), 'gi').exec(
        person.name
      );
    },
  },
  computed: {
    searchedPersons() {
      return this.persons.filter((p) => this.isSearchedPerson(p));
    },
    allSearchedPersons() {
      return this.allPersons.filter((p) => this.isSearchedPerson(p));
    },
    renderedPersons() {
      return this.showAll ? this.allSearchedPersons : this.searchedPersons;
    },
    getActions() {
      const actions = [...this.actions];

      if (this.hasSearchbar) {
        actions.splice(-1, 0, {
          label: 'Suchen',
          event: () => {
            this.showSearchbar = !this.showSearchbar;
          },
          icon: ['fas', 'search'],
        });
      }

      return actions;
    },
  },
};
</script>

<style lang="scss">
.person-list {
  user-select: none;

  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .middle {
    flex-basis: 0;
    flex-grow: 1;
    overflow: hidden;

    position: relative;
  }

  .searchbar {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100%;
  }

  .persons {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
    overflow: auto;
    max-height: 100%;

    .spacer {
      flex-grow: 1;
      flex-shrink: 1;
    }

    .person {
      margin: 5px;
    }
  }

  .no-persons {
    height: 100%;
    @include flex-center();
  }

  .action-bar {
    margin-top: 10px;
    flex-shrink: 0;
  }
}
</style>
